import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { getParsedToken } from 'models/Redemptions/selectors'

import { STRING, EVENT_TYPE } from 'resources'
import { sendAnalyticsEvent } from 'services/analytics'

import ReklaimModal, { ModalBody, ModalTitle } from 'components/ReklaimModal'
import { Button, Description } from './styles'

const CryptoQuoteExpiredModal = ({ isOpen, closeExpiredModal, crypto }) => {
  const parsedToken = useSelector(getParsedToken)

  useEffect(() => {
    if (isOpen) {
      sendAnalyticsEvent(EVENT_TYPE.redeemCryptoRateExpiredModalView, { crypto })
    }
  }, [isOpen, crypto])

  return (
    <ReklaimModal isOpen={isOpen} centered>
      <ModalBody>
        <ModalTitle>{STRING.cryptoRedeemScreen.rateExpiredModal.title}</ModalTitle>
        <Description>
          {STRING.cryptoRedeemScreen.rateExpiredModal.description(parsedToken?.expirationMinutes)}
        </Description>
        <Button onClick={closeExpiredModal}>{STRING.cryptoRedeemScreen.rateExpiredModal.buttonText}</Button>
      </ModalBody>
    </ReklaimModal>
  )
}

CryptoQuoteExpiredModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeExpiredModal: PropTypes.func.isRequired,
  crypto: PropTypes.string.isRequired,
}

export default CryptoQuoteExpiredModal
